// Vertrag mit partnerControl.deletePartner / previewDeletePartner
// (aivy-backend-app, sharedCode/partnerControl/deletePartner.js).
// Die Keys entsprechen dort COLLECTION_KEYS: counts, processed und remaining
// tragen dieselben Keys.

export const MAX_ITERATIONS = 60
export const MAX_CONSECUTIVE_ERRORS = 3
export const THROTTLE_BACKOFF_MS = 2000

export const FATES = {
  DELETE: {
    label: 'gelöscht',
    className: 'bg-red-50 text-red-700 ring-1 ring-inset ring-red-600/20'
  },
  ARCHIVE_TRANSFER: {
    label: 'archiviert & an Aivy-Standardpartner übertragen',
    className: 'bg-yellow-100 text-yellow-800'
  },
  REASSIGN: {
    label: 'an Aivy-Standardpartner umgehängt, Person gelöscht',
    className: 'bg-blue-100 text-blue-800'
  },
  NEUTRALIZE: {
    label: 'neutralisiert',
    className: 'bg-gray-100 text-gray-700'
  },
  TTL: {
    label: 'Ablaufdatum gesetzt',
    className: 'bg-gray-100 text-gray-700'
  }
}

// Reihenfolge = Anzeige-Reihenfolge im Modal.
export const DELETE_PARTNER_COLLECTIONS = [
  { key: 'employees', label: 'Teammitglieder', fate: 'DELETE' },
  { key: 'talentSpaces', label: 'Talent-Assessments', fate: 'REASSIGN' },
  { key: 'careers', label: 'Stellen', fate: 'ARCHIVE_TRANSFER' },
  { key: 'careerAnalyses', label: 'Anforderungsanalysen', fate: 'DELETE' },
  { key: 'analyses', label: 'Team-Analysen', fate: 'DELETE' },
  { key: 'reachCampaigns', label: 'Reach-Kampagnen', fate: 'DELETE' },
  { key: 'payments', label: 'Zahlungen', fate: 'DELETE' },
  { key: 'integrations', label: 'Integrationen', fate: 'DELETE' },
  { key: 'apiKeys', label: 'API-Keys', fate: 'DELETE' },
  { key: 'usageCounters', label: 'Nutzungszähler', fate: 'DELETE' },
  { key: 'cronJobs', label: 'Cron-Jobs', fate: 'NEUTRALIZE' },
  { key: 'logs', label: 'Logs', fate: 'TTL' }
]

export const COLLECTION_LABELS = Object.fromEntries(
  DELETE_PARTNER_COLLECTIONS.map(({ key, label }) => [key, label])
)

export const BLOCK_REASONS = {
  ACTIVE_PAID_PAYMENT:
    'Es gibt mindestens eine aktive, bezahlte Zahlung. Setze sie auf INACTIVE oder lasse sie ablaufen, dann kann der Kunde gelöscht werden.',
  PROTECTED_PARTNER:
    'Dieser Partner ist geschützt (Aivy-Standardpartner) und kann nicht gelöscht werden.',
  NOT_FOUND: 'Der Kunde existiert nicht (mehr).',
  MISSING_PARTNER_ID: 'Es wurde keine Partner-ID übergeben.'
}

const n = (counts, key) =>
  typeof counts?.[key] === 'number' ? counts[key] : '?'

// Punkte, die Support vor dem Löschen einzeln per Checkbox bestätigen muss.
// Deckt jedes betroffene Datenmodell ab; die Zähler kommen aus der Vorschau.
export const buildDeleteConsequences = (
  counts = {},
  archiveWindowDays = 20
) => [
  {
    key: 'employees',
    title: `Teammitglieder (${n(counts, 'employees')}) verlieren sofort den Zugang`,
    text: 'Ihre Spaces und Personendaten werden gelöscht. Die Cognito-Logins bleiben bestehen, laufen aber ohne Partner ins Leere. Wer zusätzlich Zugang zu anderen Standorten (Partnern) hat, behält diesen.'
  },
  {
    key: 'talents',
    title: `Talent-Assessments (${n(counts, 'talentSpaces')}) werden freigegeben`,
    text: 'Die Spaces werden an den Aivy-Standardpartner umgehängt und die Personendaten (Name, E-Mail, Telefon) der Talente gelöscht. Die Talente behalten ihre Ergebnisse in der Universal App, für diesen Kunden sind sie unwiderruflich weg. Demo-Talente werden komplett gelöscht.'
  },
  {
    key: 'careers',
    title: `Stellen (${n(counts, 'careers')}) werden archiviert, Analysen gelöscht`,
    text: `Stellen werden archiviert und an den Aivy-Standardpartner übertragen. Anforderungsanalysen (${n(counts, 'careerAnalyses')}), Team-Analysen (${n(counts, 'analyses')}) samt Experten-Personen und Reach-Kampagnen (${n(counts, 'reachCampaigns')}) werden gelöscht.`
  },
  {
    key: 'account',
    title: 'Vertrags- und Kontodaten werden gelöscht',
    text: `Zahlungen (${n(counts, 'payments')}), Integrationen inkl. ATS-Zugangsdaten (${n(counts, 'integrations')}), API-Keys (${n(counts, 'apiKeys')}) und Nutzungszähler (${n(counts, 'usageCounters')}) werden gelöscht, Cron-Jobs (${n(counts, 'cronJobs')}) neutralisiert, Logs (${n(counts, 'logs')}) erhalten ein Ablaufdatum. Zuletzt wird der Partner-Datensatz selbst gelöscht.`
  },
  {
    key: 'irreversible',
    title: 'Ich habe die Vorschau geprüft, es ist der richtige Kunde',
    text: `Die Löschung ist endgültig und lässt sich nur innerhalb von ${archiveWindowDays} Tagen über das Archive-Table von Entwicklern rekonstruieren. Stripe, HubSpot und S3-Dateien sind nicht Teil der Löschung und müssen separat bereinigt werden.`
  }
]
